export var Labels = {
    paymentOptionDivider: 'หรือจ่ายด้วยบัตรเครดิต'
};
